<template>
    <AdminSection title="Image">
        <ResourceInput
            label="Image"
            attribute="image"
            type="asset"
            :help-text="dimensions"
        />

        <ResourceInput
            label="Image alt tag"
            attribute="imageAlt"
            type="text"
        />
    </AdminSection>
</template>

<script>
export default {
    props: {
        dimensions: {
            type: String,
            required: false,
            default: '(960px x 510px)'
        }
    },
}
</script>
